/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: dengyao
 * @LastEditTime: 2024-04-17 14:31:33
 */
import { createApp } from 'vue'
import App from './App.vue'
import { insertBonreeScript } from './utils/bonree'
import router from './router/index'

insertBonreeScript()
import registerPlugin from './plugins/index'
import store from '@/store/store'
import directive from '@/directive/index'
import registerCompoent from '@/components/index'
import { lang } from './utils'
import request from '@/service/request'
import './assets/iconfont/iconfont.css'
import '@/assets/style/common.less'
import VueWechatTitle from 'vue-wechat-title' // 动态修改title
import echarts from '@/plugins/charts'
/** 电子签名 */
import vueEsign from 'vue-esign'

const app = createApp(App)
const packageList = [router, store, registerCompoent, directive, VueWechatTitle,vueEsign]
packageList.forEach((p) => app.use(p))

//按需注册全局组件
registerPlugin(app)
app.config.globalProperties.$lang = lang
app.config.globalProperties.$req = request
app.config.globalProperties.$echarts = echarts



app.provide('$echarts', echarts)
app.mount('#app')
